module.exports = __webpack_public_path__ + "static/media/more-horizontal.4fde0e5d.svg";